<template>
  <v-dialog v-model="dialog" persistent max-width="70vw">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        small
        tile
        outlined
        dark
        v-on="on"
        v-bind="attrs"
        class="mx-2"
        @click="dialog = true"
        ><v-icon small color="primary" class="mr-2"
          >mdi-file-alert-outline</v-icon
        >
        Upload Errors Report
      </v-btn>
    </template>

    <v-card class="mx-auto">
      <v-card-title
        >Invoice Batch Errors<v-spacer></v-spacer
        ><v-btn icon @click="clear">
          <v-icon>mdi-close</v-icon>
        </v-btn></v-card-title
      >
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title v-if="errorInvoices.length === 0" class="pt-0">
          <v-col cols="8">
            <validation-provider rules="required" v-slot="{ errors }">
              <v-file-input
                v-model="selectedFile"
                prepend-icon="mdi-paperclip"
                label="Upload Errors Report (xlsx)"
                accept=".xls, .xlsx"
                dense
                single-line
                :error-messages="errors"
              ></v-file-input>
            </validation-provider>
          </v-col>
          <v-btn
            color="primary"
            plain
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            :loading="loading"
            @click="uploadErrorsReport"
            >Upload
          </v-btn>
        </v-card-title>
      </validation-observer>

      <v-card-text v-if="errorInvoices.length > 0">
        <invoice-batch-errors
          :errorInvoices="errorInvoices"
        ></invoice-batch-errors>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import InvoiceBatchErrors from "./invoice-batch-errors.vue";
export default {
  props: ["invoiceBatchId"],
  components: {
    InvoiceBatchErrors,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedFile: null,
      errorInvoices: [],
    };
  },
  methods: {
    async uploadErrorsReport() {
      this.loading = true;
      this.errorInvoices = await this.$store.dispatch(
        "billingModule/uploadErrorsReportForInvoiceBatch",
        {
          invoiceBatchId: this.invoiceBatchId,
          selectedFile: this.selectedFile,
        }
      );
      this.loading = false;

      if (this.errorInvoices.length === 0) {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Cannot find any matching invoices for uploaded errors within this batch."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
      this.errorInvoices = [];
      this.selectedFile = null;
      this.loading = false;
      this.dialog = false;
    },
  },
};
</script>
